import React, { useEffect } from 'react'
import { FormikProps, useFormikContext } from 'formik'
import { BoxV4, NoteColors, NoteV2 } from '@labrav/react-components'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faListCheck } from '@fortawesome/pro-regular-svg-icons'
import { useStyles } from './PaymentConfiguration.styles'
import { CombinedFormState } from '../../../../modules/combinedForm/reducer'
import { MultiCurrencyForm } from '../../../../common/components/MultiCurrencyForm/MultiCurrencyForm'
import { HelpDrawer } from '@labrav/common'
import { FlyOutListingData } from '../../../../types/flyout'
import { Typography } from '@mui/material'

export type CombinedFormPaymentConfigurationProps = {
  disabled: boolean
  flyoutSellerInfo: FlyOutListingData
}

export const CombinedFormPaymentConfiguration: React.FC<
  CombinedFormPaymentConfigurationProps
> = ({ disabled, flyoutSellerInfo }) => {
  const formikProps = useFormikContext() as FormikProps<CombinedFormState>
  const { classes } = useStyles()
  useEffect(() => {
    formikProps.setFieldValue(
      'cppoData.currency',
      formikProps.values.resellerAgreementData.currency
    )
  }, [formikProps.values.resellerAgreementData.currency])
  const labraIsvId = formikProps.values.labraIsvId
  return (
    <div data-testid="flexible-section">
      <BoxV4
        // variant="small"
        heading={'Payment configuration'}
        headingIcon={
          <FontAwesomeIcon
            icon={faListCheck}
            style={{ width: '18px', height: '14px' }}
          />
        }
        secondaryActions={
          <HelpDrawer
            sectionName="combinedFormPaymentConfiguration"
            headerTitle="Help & FAQs"
          />
        }
      >
        <MultiCurrencyForm
          formik={
            formikProps as unknown as FormikProps<Record<string, unknown>>
          }
          headerText="Select currency"
          infoText={
            'Set your transaction currency for this offer. Currency must be fully set up in AMMP (AWS Marketplace Management portal) for both ISV and Channel partner, otherwise offers using it will fail.'
          }
          subTitle={
            <div style={{ width: '100%' }}>
              <NoteV2
                backgroundColor={NoteColors.YELLOW}
                description={
                  <>
                    <Typography className={classes.noteText}>
                      Select a currency configured in AMMP. Only currencies
                      supported by both the ISV and the Reseller are enabled.
                    </Typography>
                  </>
                }
              />
            </div>
          }
          keyName="resellerAgreementData.currency"
          disabled={disabled}
          flyoutSellerInfo={flyoutSellerInfo}
          labraIsvId={labraIsvId}
        />
      </BoxV4>
    </div>
  )
}
